import { render, staticRenderFns } from "./AllowedServicesSlip.vue?vue&type=template&id=4feae567&"
import script from "./AllowedServicesSlip.vue?vue&type=script&lang=js&"
export * from "./AllowedServicesSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports